import { DocumentDto } from '@bo-client/shared/models/documentDto';

export enum MeteringConceptTypeEnum {
  MeteringConcept = 'MeteringConcept',
  StorageConcept = 'StorageConcept'
}

export const MeteringConceptTypeConst: any[] = [
  {
    value: MeteringConceptTypeEnum.MeteringConcept,
    displayName: 'Messkonzept'
  },
  {
    value: MeteringConceptTypeEnum.StorageConcept,
    displayName: 'Speicherkonzept'
  }
];

export class MeteringConceptModel {
  id: number;
  name: string;
  catalogId: string;
  description: string;
  imageDocument: DocumentDto;
  isFullFeedIn: boolean;
  isFullFeedOut: boolean;
  isCommercialAccountingForwarding: boolean;
  type: MeteringConceptTypeEnum;
  sortPosition: number;
  disabled?: boolean | null;
}
